import { Component, OnInit } from '@angular/core';
import { SelectModule } from 'primeng/select';
import { UserService } from '../../../layout/service/user.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ChartModule } from 'primeng/chart';

@Component({
    selector: 'app-history',
    imports: [SelectModule, ToastModule, ButtonModule, CommonModule, FormsModule, ChartModule],
    providers: [MessageService],
    template: `
        <p-toast />
        <div class="card p-6">
            <!-- Filter Section -->
            <div class="bg-gray-50 rounded-lg p-4 mb-6 shadow-sm">
                <div class="grid grid-cols-1 md:grid-cols-3 gap-4 items-end">
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-1">Kuis</label>
                        <p-select [options]="quizs" optionLabel="name" placeholder="Pilih Kuis"
                            [(ngModel)]="selectedQuiz" (onChange)="showCases()" class="w-full" />
                    </div>
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-1">Kasus</label>
                        <p-select [options]="cases" optionLabel="name" placeholder="Pilih Kasus"
                            [(ngModel)]="selectedCase" (onChange)="showAnswers()" class="w-full" [disabled]="!selectedQuiz" />
                    </div>
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-1 invisible">Tampilkan</label>
                        <p-button severity="primary" label="Tampilkan Riwayat" icon="pi pi-plus"
                            [raised]="true" variant="outlined" styleClass="w-full" />
                    </div>
                </div>
            </div>

            <!-- Chart Section -->
            <div class="mb-8">
                <h2 class="text-lg font-semibold text-gray-800 mb-3">Grafik Nilai</h2>
                <div class="bg-white rounded-lg shadow p-4">
                    <p-chart type="bar" [data]="data" [options]="options" class="h-[30rem]" />
                </div>
            </div>

            <!-- Summary Section -->
            <div>
                <h2 class="text-lg font-semibold text-gray-800 mb-3">Ringkasan Jawaban</h2>
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    <div *ngFor="let item of summaryData; let i = index"
                        class="bg-white rounded-lg shadow-md p-5 border border-gray-100 hover:shadow-lg transition-shadow">
                        <div class="flex items-center justify-between mb-2">
                            <span class="font-semibold text-blue-700">Soal: {{ i + 1 }}</span>
                            <span class="px-3 py-1 rounded-full text-xs font-bold"
                                [ngClass]="{
                                    'bg-green-100 text-green-700': item.score == 100,
                                    'bg-yellow-100 text-yellow-700': item.score > 0 && item.score < 100,
                                    'bg-red-100 text-red-700': item.score == 0
                                }">
                                Nilai: {{ item.score }}
                            </span>
                        </div>
                        <div class="mb-2">
                            <div class="text-sm text-gray-500 mb-1">Jawaban Anda:</div>
                            <div class="overflow-x-auto">
                                <table class="min-w-full border border-gray-200 rounded-lg shadow-sm bg-gray-50">
                                    <thead>
                                        <tr>
                                            <th class="px-2 py-1 border-b font-semibold text-left text-xs bg-blue-50 text-blue-700">Kolom</th>
                                            <th class="px-2 py-1 border-b font-semibold text-left text-xs bg-blue-50 text-blue-700">Kunci Jawaban</th>
                                            <th class="px-2 py-1 border-b font-semibold text-left text-xs bg-blue-50 text-blue-700">Jawaban Anda</th>
                                            <th class="px-2 py-1 border-b font-semibold text-left text-xs bg-blue-50 text-blue-700">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let ans of parseAnswer(item.answer); let idx = index"
                                            [ngClass]="{'bg-green-50': ans.checked, 'bg-red-50': ans.checkedWrong}">
                                            <td class="px-2 py-1 border-b text-xs">{{ ans.field }}</td>
                                            <td class="px-2 py-1 border-b text-xs">{{ ans.value }}</td>
                                            <td class="px-2 py-1 border-b text-xs">{{ ans.userInput }}</td>
                                            <td class="px-2 py-1 border-b text-xs">
                                                <span *ngIf="ans.checked" class="text-green-600 font-bold">Benar</span>
                                                <span *ngIf="ans.checkedWrong" class="text-red-600 font-bold">Salah</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `
})
export class History implements OnInit {
    quizs: any[] = [];
    cases: any[] = [];
    selectedQuiz: any = null;
    selectedCase: any = null;

    summaryData: any[] = [];
    data: any = {};
    options: any = {};
    userId: any = null;
    formDetailLength: number = 0;

    constructor(
        private userService: UserService,
        private messageService: MessageService
    ) { }

    ngOnInit() {
        const user = localStorage.getItem('user');
        if (user) {
            try {
                this.userId = JSON.parse(user).ID_USER || '';
            } catch {
                this.userId = '';
            }
        }
        this.userService.getFormField().then((res) => {
            this.quizs = res.data.map((form: any) => {
                if (typeof form.fields === 'string') {
                    try {
                        form.fields = JSON.parse(form.fields);
                    } catch (error) {
                        form.fields = [];
                    }
                }
                return form;
            });
        });
    }

    showCases() {
        // Reset selected case
        this.selectedCase = null;
        if (!this.selectedQuiz) {
            this.cases = [];
            return;
        }
        // Ambil semua cases, filter berdasarkan form_id
        this.userService.getFormCases().then((res) => {
            this.cases = res.data.filter((item: any) => item.form_id === this.selectedQuiz.id);
        });
    }

    showAnswers() {
        if (!this.selectedCase) {
            this.summaryData = [];
            this.prepareChartData();
            return;
        }
        const payload = {
            user_id: this.userId,
            case_id: this.selectedCase.id
        };
        this.userService.getFormDetailsAnswer(payload)
            .then((res: any) => {
                this.summaryData = Array.isArray(res.data) ? res.data : [];
                if (this.formDetailLength === this.summaryData.length) {
                    this.finishAndShowSummary();
                }
                this.prepareChartData();
            })
            .catch((err: any) => {
                console.error('Gagal mengambil jawaban:', err);
                this.summaryData = [];
                this.prepareChartData();
            });
    }

    parseAnswer(answer: any): any[] {
        // Stub: implementasi parsing sesuai kebutuhan
        try {
            return Array.isArray(answer) ? answer : JSON.parse(answer);
        } catch {
            return [];
        }
    }

    prepareChartData() {
        if (!this.summaryData.length) {
            this.data = undefined;
            return;
        }

        const fieldSet = new Set<string>();
        this.summaryData.forEach(item => {
            const answers = this.parseAnswer(item.answer);
            answers.forEach((ans: any) => fieldSet.add(ans.field));
        });
        const fields = Array.from(fieldSet);

        const correctCounts: number[] = [];
        const wrongCounts: number[] = [];
        fields.forEach(field => {
            let correct = 0;
            let wrong = 0;
            this.summaryData.forEach(item => {
                const answers = this.parseAnswer(item.answer);
                const ans = answers.find((a: any) => a.field === field);
                if (ans) {
                    if (ans.checked) correct++;
                    if (ans.checkedWrong) wrong++;
                }
            });
            correctCounts.push(correct);
            wrongCounts.push(wrong);
        });

        const documentStyle = getComputedStyle(document.documentElement);

        this.data = {
            labels: fields,
            datasets: [
                {
                    label: 'Benar',
                    backgroundColor: documentStyle.getPropertyValue('--p-green-300'),
                    borderColor: documentStyle.getPropertyValue('--p-green-700'),
                    data: correctCounts
                },
                {
                    label: 'Salah',
                    backgroundColor: documentStyle.getPropertyValue('--p-red-300'),
                    borderColor: documentStyle.getPropertyValue('--p-red-700'),
                    data: wrongCounts
                }
            ]
        };

        this.options = {
            responsive: true,
            plugins: {
                legend: {
                    labels: {
                        color: documentStyle.getPropertyValue('--text-color')
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: documentStyle.getPropertyValue('--text-color-secondary')
                    },
                    grid: {
                        color: documentStyle.getPropertyValue('--surface-border')
                    }
                },
                y: {
                    beginAtZero: true,
                    ticks: {
                        color: documentStyle.getPropertyValue('--text-color-secondary')
                    },
                    grid: {
                        color: documentStyle.getPropertyValue('--surface-border')
                    }
                }
            }
        };
    }

    finishAndShowSummary() {
        // Stub: implementasi jika perlu
    }
}
